import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';
import theme from 'styled-theming';
import darken from 'polished/lib/color/darken';
import lighten from 'polished/lib/color/lighten';
import { BUTTON_VARIANTS, BUTTON_SIZES } from './constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
const baseStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n\n  border: none;\n  border-radius: ", ";\n  box-shadow: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  line-height: 1;\n  font-weight: bold;\n  text-decoration: none;\n\n  transition: ", ";\n  cursor: pointer;\n\n  [dir='rtl'] & {\n    font-family: ", ";\n    text-transform: none;\n  }\n\n  ", "\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: ", ";\n      border-color: ", ";\n    }\n    &:active {\n      box-shadow: ", ";\n    }\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.halfSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.radii.default;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.boxShadows.default;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.contrastText;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.fonts.heading;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.transitionsMs.default;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.rtlFonts.heading;
}, _ref8 => {
  let {
    theme: {
      colors
    }
  } = _ref8;
  return theme('name', {
    pureGym: "\n        border: 1px solid ".concat(colors.opacities.invertedSubtle, ";\n        text-transform: uppercase;\n      ")
  });
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.accents.muted;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.opacities.invertedSubtle;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.boxShadows.selected;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.boxShadows.focus;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.opacities.disabled;
});
const menuItemStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  text-align: left;\n\n  > svg {\n    font-size: 1em;\n    flex-shrink: 0;\n\n    &:last-child:not(:only-child) {\n      margin-inline-start: auto;\n    }\n  }\n"])));
const primaryVariant = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"])), _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.primary.main;
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.colors.primary.contrastText;
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colors.primary.contrastText;
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.colors.primary.light;
});
const secondaryVariant = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"])), _ref18 => {
  let {
    theme
  } = _ref18;
  return theme.colors.secondary.main;
}, _ref19 => {
  let {
    theme
  } = _ref19;
  return theme.colors.secondary.contrastText;
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.colors.secondary.contrastTextLight;
}, _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.colors.secondary.light;
});
const outlineVariant = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  color: currentColor;\n  border: 1px solid currentColor;\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      border-color: currentColor;\n      color: ", ";\n      background: ", ";\n    }\n  }\n"])), _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.colors.text;
}, _ref23 => {
  let {
    theme
  } = _ref23;
  return theme.colors.accents.muted;
});
const premiumVariant = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"])), _ref24 => {
  let {
    theme
  } = _ref24;
  return theme.colors.brandAccents.purple;
}, _ref25 => {
  let {
    theme
  } = _ref25;
  return theme.colors.brandAccents.lightTeal;
}, _ref26 => {
  let {
    theme
  } = _ref26;
  return theme.colors.brandAccents.lightTeal;
}, _ref27 => {
  let {
    theme
  } = _ref27;
  return lighten(0.1, theme.colors.brandAccents.purple);
});
const linkVariant = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  font-family: ", ";\n  font-weight: normal;\n  text-decoration: underline;\n  text-transform: none;\n  color: ", ";\n\n  > svg {\n    font-size: 1em;\n  }\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: transparent;\n      box-shadow: none;\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    text-decoration: none;\n    color: ", ";\n  }\n\n  [dir='rtl'] & {\n    font-family: ", ";\n  }\n"])), _ref28 => {
  let {
    theme
  } = _ref28;
  return theme.fonts.body;
}, _ref29 => {
  let {
    theme: {
      colors
    }
  } = _ref29;
  return theme('mode', {
    light: colors.primary.main,
    dark: colors.primary.light
  });
}, _ref30 => {
  let {
    theme: {
      colors
    }
  } = _ref30;
  return theme('mode', {
    light: colors.primary.dark,
    dark: colors.primary.main
  });
}, _ref31 => {
  let {
    theme
  } = _ref31;
  return theme.colors.text;
}, _ref32 => {
  let {
    theme
  } = _ref32;
  return theme.rtlFonts.body;
});
const plainVariant = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: ", ";\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  color: currentColor;\n\n  > svg {\n    font-size: 1.2em;\n  }\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      background: transparent;\n      color: ", ";\n\n      ", "\n    }\n  }\n\n  &:disabled {\n    color: currentColor;\n    opacity: ", ";\n  }\n"])), _ref33 => {
  let {
    theme
  } = _ref33;
  return theme.spacing.halfSpacing;
}, _ref34 => {
  let {
    theme
  } = _ref34;
  return theme.colors.primary.main;
}, _ref35 => {
  let {
    theme: {
      colors
    }
  } = _ref35;
  return theme('name', {
    pureGym: "\n            color: ".concat(colors.secondary.main, ";\n          ")
  });
}, _ref36 => {
  let {
    theme
  } = _ref36;
  return theme.opacities.disabled;
});
const subduedVariant = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n      background: ", ";\n    }\n  }\n"])), _ref37 => {
  let {
    theme
  } = _ref37;
  return theme.colors.accents.muted;
}, _ref38 => {
  let {
    theme
  } = _ref38;
  return theme.colors.text;
}, _ref39 => {
  let {
    theme
  } = _ref39;
  return theme.colors.text;
}, _ref40 => {
  let {
    theme
  } = _ref40;
  return darken(0.1, theme.colors.accents.muted);
});
const variants = {
  [BUTTON_VARIANTS.PRIMARY]: primaryVariant,
  [BUTTON_VARIANTS.SECONDARY]: secondaryVariant,
  [BUTTON_VARIANTS.PREMIUM]: premiumVariant,
  [BUTTON_VARIANTS.OUTLINE]: outlineVariant,
  [BUTTON_VARIANTS.LINK]: linkVariant,
  [BUTTON_VARIANTS.PLAIN]: plainVariant,
  [BUTTON_VARIANTS.SUBDUED]: subduedVariant
};
const smallSize = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  padding: 4px 9px;\n"])), _ref41 => {
  let {
    theme
  } = _ref41;
  return theme.fontSizes.small;
});
const mediumSize = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  padding: ", ";\n"])), _ref42 => {
  let {
    theme
  } = _ref42;
  return theme.fontSizes.standard;
}, _ref43 => {
  let {
    theme
  } = _ref43;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.baseSpacing);
});
const largeSize = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  padding: ", ";\n"])), _ref44 => {
  let {
    theme
  } = _ref44;
  return theme.fontSizes.large;
}, _ref45 => {
  let {
    theme
  } = _ref45;
  return "9px ".concat(theme.spacing.baseSpacing);
});
const sizes = {
  [BUTTON_SIZES.SMALL]: smallSize,
  [BUTTON_SIZES.MEDIUM]: mediumSize,
  [BUTTON_SIZES.LARGE]: largeSize
};

export { baseStyles, menuItemStyles, sizes, variants };
